import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { usePermissions } from 'modules/taboola-common-frontend-modules/authentication';
import { useRecommendationsApi } from 'services/api/recommendationsApi';

const useFetchCampaignNotificationTargetItemIds = (accountId, campaignId, recommendationTypes) => {
    const recommendationsApi = useRecommendationsApi();
    const key = [accountId, campaignId, 'recommendations'];
    const isAllowed = usePermissions('CAMPAIGN_PERFORMANCE_RECOMMENDATIONS');
    const isPermitted = !!(isAllowed && accountId);
    const { data: { results: recommendations } = {}, isLoading } = useQuery(
        key,
        () => recommendationsApi.getCampaignRecommendations(accountId, campaignId, recommendationTypes),
        {
            enabled: isPermitted,
        }
    );

    const targetItemIds = useMemo(() => {
        if (isLoading || !recommendations) {
            return [];
        }
        return recommendations.map(recommendation => {
            return recommendation.messageParams.itemIds;
        });
    }, [isLoading, recommendations]);

    return {
        targetItemIds,
        isLoading,
    };
};

export default useFetchCampaignNotificationTargetItemIds;
